import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useCurrentCompany } from "ui/context/auth";
import { useRestApi } from "ui/context/restApi";

import { queryKeys } from "./queryKeys";

export const useTeamsQuery = () => {
  const { getTeams } = useRestApi();
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.TEAMS, currentCompany.id],
    queryFn: () => getTeams(currentCompany.id),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
